/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessPartnerPromotionViewProps } from './business-partner-promotion';

/**
 * View layout of business partner promotion module.
 * @param props - React props of the component.
 * @returns Functional component.
 */
const businessPartnersView: React.FC<IBusinessPartnerPromotionViewProps> = props => {
    const {
        businessPartnerPromotionProps,
        heading,
        notificationMessage,
        sellerDescriptions,
        termsOfServiceCheckbox,
        termsOfServiceModal,
        submitButton
    } = props;
    return (
        <Module {...businessPartnerPromotionProps}>
            {heading}
            {notificationMessage}
            {sellerDescriptions}
            {termsOfServiceCheckbox}
            {termsOfServiceModal}
            {submitButton}
        </Module>
    );
};

export default businessPartnersView;
